import MotorcycleFinancingScreen from '../screens/MotorcycleFinancing'
import AppMotorcycleFinancingScreen from '../screens/App-MotorcycleFinancing'
import { NextPage } from 'next'
import { ScreenWidthPort } from '../ScreenWidthContext'

export const MotorcycleFinancing: NextPage = () => {
  const { showDesktopUI } = ScreenWidthPort()

  return (
    <>
      {showDesktopUI ? (<MotorcycleFinancingScreen />) : (<AppMotorcycleFinancingScreen />)}
    </>
  )
}
